/**
 * Impersonation (section 5.5) : page d'atterrissage qui échange le jeton à usage unique
 * contre une session utilisateur (stockée en sessionStorage, isolée à cet onglet), puis
 * recharge l'app établissement. Bannière permanente « connecté en tant que » avec « Quitter ».
 */
import { useEffect, useState } from 'react';
import { impersonateExchange, setSessionToken, TOKEN_KEY } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

// Garde au niveau module : persiste au double-montage StrictMode (dev) afin de n'échanger
// le jeton à usage unique qu'UNE SEULE fois (sinon le 2e appel échoue « déjà utilisé »).
let _handledToken = null;

export function ImpersonateLanding() {
  const [error, setError] = useState(null);
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setError('Jeton manquant'); return; }
    if (_handledToken === token) return; // échange déjà tenté pour ce jeton
    _handledToken = token;
    impersonateExchange(token)
      .then(({ token: jwt }) => { setSessionToken(jwt); window.location.replace('/'); })
      .catch((e) => setError(e.message || 'Échec de la connexion'));
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      {error ? <p className="adm-text-error" data-testid="impersonate-error">{error}</p>
        : <p className="text-n600">Ouverture de la session…</p>}
    </div>
  );
}

export function ImpersonationBanner() {
  const { user } = useAuth();
  if (!user?.impersonated) return null;
  const quit = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    window.close();
    window.location.replace('/login');
  };
  return (
    <div className="shrink-0 w-full flex items-center justify-center gap-4 px-4 py-2 text-sm text-white"
      style={{ background: '#2a4862' }} data-testid="impersonation-banner">
      <span>Session super-admin : connecté en tant que <b>{user.name}</b></span>
      <button className="underline" onClick={quit} data-testid="impersonation-quit">Quitter</button>
    </div>
  );
}
